var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm._m(0)
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "component" }, [
      _c("div", { staticClass: "main-title" }, [
        _c("div", { staticClass: "square" }),
        _vm._v(" "),
        _c("div", { staticClass: "title-content" }, [_vm._v("关系圈")])
      ])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }